import UserSignInTask from './tasks/UserSignInTask.js';
import MaintenanceTask from './tasks/MaintenanceTask.js';
import UserAgentWarningTask from './tasks/UserAgentWarningTask.js';
import UserActivationTask from './tasks/UserActivationTask.js';
import ActiveTabWarningTask from './tasks/ActiveTabWarningTask.js';
import EmailConfirmationTask from './tasks/EmailConfirmationTask.js';
import InstitutionSignInTask from './tasks/InstitutionSignInTask.js';

class App {
    static create(params) {
        return new App(params);
    }

    constructor({env}) {
        this.env = env;
        this.initEvents();
    }

    initEvents() {
        window.addEventListener('error', () => this.onUnexpectedError());
        window.addEventListener('unhandledrejection', () => this.onUnexpectedError());
    }

    onUnexpectedError() {
        this.env.showDialog('unexpected-error-dialog');
    }

    async run() {
        this.env.showDialog('loading-dialog');

        await MaintenanceTask.run({env: this.env});
        await EmailConfirmationTask.run({env: this.env});
        await UserActivationTask.run({env: this.env});
        await ActiveTabWarningTask.run({env: this.env});

        this.env.clearNonSACookies();

        await InstitutionSignInTask.run({env: this.env});
        await UserAgentWarningTask.run({env: this.env});

        UserSignInTask.run({env: this.env});
    }
}

export default App;